import { PRODUCT_STOCK_SERVICE_URL } from 'product/constants/constants'
import type { Product } from 'product/types/Product'
import type { Stock } from 'product/types/Stock'
import type { PageParams } from 'types/pageParams/PageParams'
import { env } from 'utils/envManager/envManager'

interface GetClientProductStock {
	productId: Product['id']
	country: PageParams['country']
	enabled?: boolean
}

export const getClientProductStock = async (
	params: GetClientProductStock
): Promise<Stock | null> => {
	const { productId, country } = params

	const url = new URL(
		PRODUCT_STOCK_SERVICE_URL,
		env.NEXT_PUBLIC_ORCHESTRATOR_DOMAIN
	)

	const searchParams = new URLSearchParams({
		countryIso: country.toUpperCase(),
		channelId: env.NEXT_PUBLIC_CHANNEL,
		productId,
	})

	url.search = searchParams.toString()

	const response = await fetch(url.href, {
		next: {
			revalidate: 0,
		},
	})

	if (response.ok) {
		return response.json()
	}

	return null
}
